import React, { RefObject } from 'react'
import { css, injectGlobal } from 'emotion'
import AntSelect, { SelectProps } from 'antd/es/select'
import 'antd/es/select/style/css'

import AntTag from 'antd/es/tag'
import 'antd/es/tag/style/css'

import { P1Bold } from 'src/components/Typography'
import { useTheme } from 'src/shared/themeContext'
import { MAIN_COLORS } from 'src/shared/ColorStyles'
import { MAIN_FONT, FONT_SIZE } from 'src/shared/TypographyStyles'

import style from './style'

injectGlobal`
  .ant-select-dropdown .ant-select-item-option {
    -webkit-font-smoothing: antialiased;
    color: ${MAIN_COLORS.PRIMARY_BLACK};
    font-family: ${MAIN_FONT};
    font-size: ${FONT_SIZE.P1};
    font-weight: 400;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    font-weight: 500;
  }

  div.ant-select-dropdown {
    border-radius: 5px;
    max-height: 100vh;
    overflow-y: scroll;
  }
`

export type Props = {
  disabled?: boolean
  children?: React.ReactNode
  className?: string
  type: 'dropdown' | 'filter'
  placeholder?: string
  style?: Record<string, unknown>
  dropdownstyle?: Record<string, unknown>
  open?: boolean
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  mode?: 'multiple' | 'tags'
  label?: string
  dropdownAlign?: object // ref: https://github.com/yiminghe/dom-align
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectRef?: RefObject<any>
} & Omit<SelectProps<any>, 'disabled' | 'mode' | 'className'>

const Select = function({
  className = '',
  children,
  disabled = false,
  type,
  mode,
  label,
  selectRef,
  ...rest
}: Props) {
  const { spacing, brand } = useTheme()

  injectGlobal`
    .ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background-color: #F0FFF9 /* ${brand.primary.background} */;

      .ant-select-item-option-state {
        color: #00D37E /* ${brand.primary.illustration} */;

        &:hover {
          border-color: ${brand.primary.default};
        }
  
        &.ant-picker-focused {
          border-color: ${brand.primary.default};
        }
  
        .ant-picker-active-bar {
          background: ${brand.primary.default};
        }
      }
    }
  `

  const styleString = style({ mode, disabled, type })

  return (
    <>
      {label && <P1Bold style={{ marginBottom: spacing.xs }}>{label}</P1Bold>}
      <AntSelect
        className={`${css(styleString)} ${className}`}
        disabled={disabled}
        mode={mode}
        ref={selectRef}
        {...rest}
      >
        {children}
      </AntSelect>
    </>
  )
}

Select.Tag = function({ className = '', ...props }) {
  const {
    brand: { primary }
  } = useTheme()

  const tagStyle = `
    height: 28px;
    color: #FFFFFF;
    background: ${primary.default};
    border-radius: 23px;
    border: 0;
    display: inline-flex;
    align-items: center;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    padding-left: 10px;
    cursor: pointer;
    font-family: ${MAIN_FONT};
    padding-right: 10px;
    margin-right: 4px;

    &:hover {
      opacity: 1;
    }

    &.ant-tag .anticon-close {
      color: white;
      margin-left: 5px;
      margin-top: 0px;
    }
  `
  return <AntTag className={`${css(tagStyle)} ${className}`} {...props} />
}

Select.OptGroup = AntSelect.OptGroup
Select.Option = AntSelect.Option

export default Select
